import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  selectRoomAlertDeviceList,
  selectSensorMap,
} from '../../../../redux/slices/deviceList/deviceListSlice';
import { getAlertRowDisplayData } from '../AlertFormUtility';

function asArray(value) {
  return Array.isArray(value) ? value : [];
}

function AlertNamesTable(props) {
  const { alertNamePairs } = props;

  const deviceList = useSelector(selectRoomAlertDeviceList);
  const sensorMap = useSelector(selectSensorMap);

  const rows = useMemo(
    () => asArray(alertNamePairs).map((pair) => getAlertRowDisplayData(
      pair ? pair.channelKey : null,
      pair ? pair.alertName : null,
      deviceList,
      sensorMap,
    )),
    [alertNamePairs, deviceList, sensorMap],
  );

  return (
    <div
      className="table-responsive"
      style={{
        maxHeight: 420,
        overflowY: 'auto',
        border: '1px solid #dee2e6',
        borderRadius: 4,
      }}
    >
      <table className="table table-striped mb-0">
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td className="text-muted">
                No alert names to review.
              </td>
            </tr>
          ) : (
            rows.map((row, idx) => (
              <tr key={`${String(row.key)}-${idx}`}>
                <td>
                  <strong>{row.alertName}</strong>
                  {' '}
                  {row.details}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

AlertNamesTable.propTypes = {
  alertNamePairs: PropTypes.arrayOf(PropTypes.shape({
    channelKey: PropTypes.string.isRequired,
    alertName: PropTypes.string.isRequired,
  })).isRequired,
};

export default AlertNamesTable;
